import type { UpdateHarmonyPackageDocumentPayload } from '@rhythmic/types'
import type { Transaction } from '@tanstack/vue-db'
import { useRhythmicLogger } from '#imports'
import { getHarmonyDocumentCollection } from '../getCollections'
import type { DocumentContext } from './useDocumentContext'

const logger = useRhythmicLogger('useHarmonyPlanContext:updateDocument')

function validateParams(documentId: string, payload: UpdateHarmonyPackageDocumentPayload, context: DocumentContext) {
  const { workspaceId, packageId } = context

  if (!workspaceId) throw new Error('Workspace identifier is required to update a harmony plan document')

  const updates: Record<string, unknown> = {}

  for (const [key, value] of Object.entries(payload)) {
    if (value !== undefined) updates[key] = value
  }

  if (Object.keys(updates).length === 0)
    throw new Error('At least one field must be provided to update a harmony plan document')

  return { documentId, workspaceId, packageId, updates }
}
export function handleUpdateDocument(
  docId: string,
  payload: UpdateHarmonyPackageDocumentPayload,
  context: DocumentContext,
): Transaction {
  try {
    const { documentId, workspaceId, packageId, updates } = validateParams(docId, payload, context)

    const collection = getHarmonyDocumentCollection(packageId)
    const transaction = collection.update(documentId, (draft) => {
      Object.assign(draft, updates)
    })

    logger.info('Harmony package document updated', {
      packageId,
      workspaceId,
      documentId,
    })
    return transaction
  } catch (error) {
    logger.error('Failed to update harmony plan document', { docId, error })
    if (error instanceof Error) throw error

    throw new Error('Failed to update harmony plan document', { cause: error })
  }
}
